import toastr from 'toastr';

const loginModal = () => {
  $(() => {
    // Password visibility toggle
    $('.js-password-toggle').on('click', function (e) {
      e.preventDefault();
      const $input = $(this).closest('.c-form-input-wrapper').find('.js-password-input');
      const $icon = $(this).find('.js-password-icon');

      if ($input.attr('type') === 'password') {
        $input.attr('type', 'text');
        $icon.removeClass('icon-new-eye-slash').addClass('icon-new-eye');
      } else {
        $input.attr('type', 'password');
        $icon.removeClass('icon-new-eye').addClass('icon-new-eye-slash');
      }
    });

    // Handle AJAX form submission to prevent redirect to /workshops on success
    $('#loginModalForm').on('submit', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $submitBtn = $form.find('input[type="submit"]');
      const originalBtnText = $submitBtn.val();

      $submitBtn.prop('disabled', true).val('Logging in...');
      $form.find('.c-form-input').removeClass('is-invalid');

      $.ajax({
        url: `${$form.attr('action')}.json`,
        type: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        success() {
          // Successfully logged in via Devise JSON response, reload page
          window.location.reload();
        },
        error(jqXHR) {
          $submitBtn.prop('disabled', false).val(originalBtnText);

          if (jqXHR.status === 401) {
            const response = jqXHR.responseJSON || {};

            if (response.redirect_url) {
              window.location.href = response.redirect_url;
              return;
            }

            if (response.error) {
              toastr.error(response.error, '', {
                closeButton: true,
                progressBar: true,
              });
            } else {
              toastr.error('Invalid email or password.', '', {
                closeButton: true,
                progressBar: true,
              });
            }
            $form.find('.c-form-input').addClass('is-invalid');
          } else {
            toastr.error('Oops! Something went wrong. Please try again later.', '', {
              closeButton: true,
              progressBar: true,
            });
          }
        },
      });
    });

    // Handle focus when modal is shown (fixes aria-hidden warning)
    $('#loginModal').on('shown.bs.modal', function () {
      $('#loginModalEmail').trigger('focus');
    });
  });
};

export default loginModal;
